module.exports = __webpack_public_path__ + "img/logo-sd-cci-icon.cb759d4b.png";